import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import { getActiveCrawlerSection } from '@hydra/utils/parseRouteParams';

import IssueCounterRow from '@hydra/routes/crawler/components/IssueCounterRow';

export class EcommerceCategory extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    params: PropTypes.shape({
      lang: PropTypes.string,
      url: PropTypes.string
    }).isRequired,
    project: PropTypes.shape({
      host: PropTypes.string,
      crawl: PropTypes.shape({
        EcommerceCategory: PropTypes.shape({
          countProducts: PropTypes.number,
          countProductIssues: PropTypes.number
        })
      })
    }),
    location: PropTypes.object,
    url: PropTypes.string
  }

  static childContextTypes = {
    location: PropTypes.object
  }

  getChildContext () {
    return {
      location: this.props.location
    };
  }

  getCounters (props) {
    const { lang, url } = props.params;
    const activeSection = getActiveCrawlerSection(props.routes);
    const baseUrl = `/${lang}/crawler/${encodeURIComponent(url)}/ecommerce`;
    const crawlNode = get(props, 'project.crawls.edges[0].node', {});

    return [
      {
        active: activeSection === 'products',
        amount: crawlNode.countProducts || 0,
        label: <Translate content='crawler_products' />,
        link: `${baseUrl}/products`,
        name: 'products'
      },
      {
        active: activeSection === 'product-issues',
        amount: crawlNode.countProductIssues || 0,
        label: <Translate content='crawler_product_issues' />,
        link: `${baseUrl}/product-issues`,
        name: 'product-issues'
      }
    ];
  }

  render () {
    const { children } = this.props;

    return (
      <div className='nr-crawler-ecommerce-category'>
        <IssueCounterRow counters={this.getCounters(this.props)} />
        {children}
      </div>
    );
  }
}

export default createFragmentContainer(EcommerceCategory, {
  project: graphql`
    fragment EcommerceCategory_project on Project {
      host
      crawls (offset: 0, limit: 1) {
        edges {
          cursor,
          node {
            countProducts
            countProductIssues
          }
        }
      }
    }
  `
});
